import React, { useEffect, useRef } from 'react';
import {
  Button, Table, Popover,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import SpecialCard from '@pages/Alarmas_EditCreate/components/SpecialCard';
import TagCondition from '@pages/Alarmas_EditCreate/components/TagCondition';

import SimpleCondition from '../SimpleCondition';
import useGroupCondition from './useGroupCondition';
import styles from './GroupCondition.module.less';

function GroupCondition(props) {

  const { t } = useTranslation();
  const count = useRef(0);
  const { index } = props;
  const {
    orConditions, addOrCondition, isEditDefault,
    valueType,
    columnsDataInfo,
  } = useGroupCondition({
    index,
  });

  useEffect(() => {

    count.current += 1;

  });

  const AuxModal = () => (
    <>
      <Table
        className={styles.table}
        columns={columnsDataInfo}
        dataSource={valueType}
        scroll={{ y: 440 }}
        style={{
          width: 600,
        }}
        // pagination={{ pageSize: 6 }}
        rowKey={(record) => `${record.name}_${record.value}_${record.typeId}`}
      />
    </>
  );

  return (
    <SpecialCard>
      <div className={styles.top_elements}>
        <TagCondition />
        <div>
          <p className={styles.textInfo}>{t('views.device_graphics.invertersLogs.MoreInfo')}</p>
          <Popover content={AuxModal} placement="leftTop">
            <FontAwesomeIcon className={styles.iconInfo} icon={faInfoCircle} />
          </Popover>
        </div>
      </div>

      <div className={styles.list_conditions}>
        {orConditions.map((_, conditionIndex) => {

          const key = `or_condition_${index}_${conditionIndex}_${count.current}`;
          const isLastItem = index === orConditions.length - 1;
          return (
            <>
              <SimpleCondition
                key={key}
                groupIndex={index}
                index={conditionIndex}
                isLastItem={isLastItem}
              />
            </>
          );

        })}
        {/* {orConditions.map((_, conditionIndex) => {
          const key = `or_condition_${index}_${conditionIndex}`;
          const isLastItem = index === orConditions.length - 1;
          return (
            <SimpleCondition
              key={key}
              groupIndex={index}
              index={conditionIndex}
              isLastItem={isLastItem}
            />
          );
        })} */}
      </div>

      <Button className={styles.btn_add_condition} type="dashed" onClick={() => addOrCondition()} disabled={isEditDefault}>
        {t('views.dynamic_alarms_create_edit.buttons.add_condition')}
      </Button>
    </SpecialCard>
  );

}

GroupCondition.propTypes = {
  index: PropTypes.number.isRequired,
};

export default GroupCondition;
